<script setup=""></script>

<template>
  <svg fill="currentColor" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
    <path
      clip-rule="evenodd"
      d="M27.4637 6.28767C28.7262 6.624 29.7197 7.62265 30.056 8.89554C30.6666 11.1981 30.6614 15.9999 30.6614 15.9999C30.6614 15.9999 30.6614 20.8017 30.0508 23.1043C29.7145 24.372 28.721 25.3706 27.4585 25.7121C25.1714 26.3279 15.9973 26.3279 15.9973 26.3279C15.9973 26.3279 6.82323 26.3279 4.53617 25.7121C3.27363 25.3758 2.28016 24.3772 1.94382 23.1043C1.33325 20.8017 1.33325 15.9999 1.33325 15.9999C1.33325 15.9999 1.33325 11.1981 1.949 8.89036C2.28533 7.62265 3.2788 6.624 4.54134 6.28249C6.8284 5.66675 16.0025 5.66675 16.0025 5.66675C16.0025 5.66675 25.1714 5.66675 27.4637 6.28767ZM13.0014 11.638V20.3619L20.6698 15.9999L13.0014 11.638Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
